import React from 'react';
import { connect } from "react-redux";
import { updateData } from "../actions";
import * as dateFns from 'date-fns'
import ReactTooltip from 'react-tooltip';
import If from '../../helper/component/If'
import ControlService from '../../helper/controlservice';

const _ = require("lodash");

class LabelUi extends React.PureComponent {
    state = {
        pagesearchtext: null
    }
    componentDidMount() {
        if (window.location.host) {
            var _localStorage = localStorage.hasOwnProperty(window.location.href) ? localStorage.getItem(window.location.href) : null;
            if (_localStorage) {
                this.setState({
                    pagesearchtext: _localStorage
                })
            } else {
                var pagesearchtext = localStorage.hasOwnProperty('pagesearchtext') ? localStorage.getItem('pagesearchtext') : null;
                if (pagesearchtext) {
                    localStorage.setItem(window.location.href, pagesearchtext);
                    this.setState({
                        pagesearchtext: pagesearchtext
                    })
                }
            }
        }
    }
    gethtml(control, Text) {
        var _text = Array.isArray(Text) ? Text.map(k => k).join(', ') : Text;
        var s = "<" + control.formattype + ">" + _text + "</" + control.formattype + ">";
        return { __html: s };
    }
    getValue(control, data) {
        if (data[control.valueField] !== "" && data[control.valueField] !== undefined && data[control.valueField] != null) {
            var _data = typeof data[control.valueField] == 'string' ? data[control.valueField] : Array.isArray(data[control.valueField]) ? data[control.valueField].map(k => k).join(', ') : data[control.valueField];
            if (this.state.pagesearchtext && this.state.pagesearchtext != "undefined" && this.state.pagesearchtext != "null" && typeof data[control.valueField] == 'string') {
                const pagesearchtext = JSON.parse(JSON.parse(this.state.pagesearchtext));
                pagesearchtext.forEach((item) => {
                    if (typeof item === "string" && item && item.trim() !== '' && _data && _data.length > 50) {
                        item = item.replace('”', '');
                        item = item.replace('“', '');
                        item = item.replace(/"/g, '');
                        // item = item.replace('*', '');
                        if (item.indexOf("*") > -1) {
                            var matched = _data.match(new RegExp("\\b(" + item.trim().replace("*", "\\w*)\\b"), 'gi'));
                            if (matched && matched.length > 0) {
                                matched = _.uniqBy(matched);
                                matched.forEach(_match => {
                                    _data = _data.replace(new RegExp("\\b(" + _match.trim() + ")\\b", 'gi'), match => {
                                        return '<mark>' + match.trim() + '</mark>';
                                    });
                                })
                            }
                        } else {
                            if (item.trim() !== '' && _data.match(new RegExp("\\b(" + item.trim() + ")\\b", 'gi'))) {
                                _data = _data.replace(new RegExp("\\b(" + item.trim() + ")\\b", 'gi'), match => {
                                    return '<mark>' + match.trim() + '</mark>';
                                });
                            } else if (item.trim() !== '' && _data.match(new RegExp(item.trim() + "(?:$|\W)", 'gi'))) {
                                _data = _data.replace(new RegExp(item.trim() + "(?:$|\W)", 'gi'), match => {
                                    return '<mark>' + match.trim() + '</mark>';
                                });
                            } else if (item.trim() !== '' && _data.match(new RegExp('(?:^|)' + item.trim() + '(?:$|)', 'gi'))) {
                                _data = _data.replace(new RegExp('(?:^|\\W)' + item.trim() + '(?:$|\\W)', 'gi'), match => {
                                    return '<mark>' + match.trim() + '</mark>';
                                });
                            }
                        }
                    } else if (item.value && item.value.trim() !== '' && _data && _data.length > 50) {
                        _data = _data.replace(new RegExp("\\b(" + item.value.trim() + ")\\b", 'gi'), match => {
                            return '<mark>' + match.trim() + '</mark>';
                        });
                    }
                })
            }
            if (control.formattype && control.formattype !== "") {
                if (control.outputtype) {
                    if (control.outputtype == "date") {
                        let date = new Date(_data);
                        if (date instanceof Date) {
                            _data = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
                        }
                    }

                }
                if (control.formattype === 'plain') {
                    return { __html: _data };
                } else if (control.formattype !== 'plain') {
                    return this.gethtml(control, _data);
                }
            } else {
                if (control.outputtype) {
                    if (control.outputtype == "date") {
                        let date = new Date(_data);
                        if (date instanceof Date) {
                            _data = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
                        }
                    }

                }
                return { __html: _data };
            }
        } else {
            return { __html: '' };
        }
    }
    getDistanceInWord(data) {
        if (data) {
            return dateFns.formatDistance(new Date(data), new Date(), { addSuffix: true, includeSeconds: true });
        } else {
            return '';
        }
    }
    commaSeparatedMath(data, apiField){
        if (data) {
            if(apiField){
                var getValue = [];
                data.forEach(item =>{
                    getValue.push(item[apiField])
                });

                return getValue.join(', ');
            }else{
                return data.join(', ');
            }
        }else{
            return '';
        }
    }
    render() {

        const { control, formid, token } = this.props;
        var data = this.props.data[formid] ? this.props.data[formid] : {};

        return (
            <React.Fragment>
                <If show={control.viewtype == 'namevalue'}>
                    <div data-tip data-for={control.id} className={(control.customClass) + ' ' + (control.horizontalalignment) + ' ' + (control.verticalalignment) + ' ' + (control.oneline && ' d-flex') + ' ' + (!control.oneline && ' form-group')}>
                        {(control.Text || control.WebIcon) &&
                            <label className={'text-muted ' + (control.oneline + ' mb-0 pr-2')}>
                                {control.Text}
                            </label>
                        }
                        {control.outputtype == 'time' ?
                            <div className={(control.oneline ? ' ' : ' form-control ') + ' ' + ' border-0 px-0 ' + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                {control.WebIcon &&
                                    <i className={(control.WebIcon) + ' mr-2'}></i>
                                }
                                {this.getDistanceInWord(data[control.valueField])}
                            </div>
                            : control.outputtype == 'datetime' ?
                                <div className={(control.oneline ? ' ' : ' form-control ') + ' ' + ' border-0 px-0 ' + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                    {control.WebIcon &&
                                        <i className={(control.WebIcon) + ' mr-2'}></i>
                                    }
                                    {data[control.valueField] ? ControlService().utcToZonedTime(data[control.valueField], control.dateformat, token) : ''}
                                </div>
                                : control.outputtype == 'email' ?
                                    <div className={(control.oneline ? ' ' : ' form-control ') + ' ' + ' border-0 px-0 ' + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                        <a href={'mailto:' + data[control.valueField]}>
                                            {control.WebIcon &&
                                                <i className={(control.WebIcon) + ' mr-2'}></i>
                                            }
                                            {data[control.valueField]}
                                        </a>
                                    </div>
                                    : control.outputtype == 'phone' ?
                                        <div className={(control.oneline ? ' ' : ' form-control ') + ' ' + ' border-0 px-0 ' + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                            <a href={'tel:' + data[control.valueField]}>
                                                {control.WebIcon &&
                                                    <i className={(control.WebIcon) + ' mr-2'}></i>
                                                }{data[control.valueField]}
                                            </a>
                                        </div>
                                        : control.outputtype == 'website' ?
                                            <div className={(control.oneline ? ' ' : ' form-control ') + ' ' + ' border-0 px-0 ' + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                                <a target='_blank' href={data[control.valueField]}>
                                                    {control.WebIcon &&
                                                        <i className={(control.WebIcon) + ' mr-2'}></i>
                                                    }{data[control.valueField]}
                                                </a>
                                            </div>
                                            : control.outputtype == 'commaSeparatedObject' ?
                                            <div className={(control.oneline ? ' ' : ' form-control ') + ' ' + ' border-0 px-0 ' + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                                {control.WebIcon &&
                                                    <i className={(control.WebIcon) + ' mr-2'}></i>
                                                }{this.commaSeparatedMath(data[control.valueField],control.separateValueField)}
                                            </div>
                                            : control.outputtype == 'commaSeparatedArray' ?
                                            <div className={(control.oneline ? ' ' : ' form-control ') + ' ' + ' border-0 px-0 ' + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                                {control.WebIcon &&
                                                    <i className={(control.WebIcon) + ' mr-2'}></i>
                                                }{this.commaSeparatedMath(data[control.valueField])}
                                            </div>
                                            :
                                            <div className={(control.oneline ? ' ' : ' form-control ') + ' ' + ' border-0 px-0 ' + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                                {control.WebIcon &&
                                                    <i className={(control.WebIcon) + ' mr-2'}></i>
                                                }<span dangerouslySetInnerHTML={this.getValue(control, data)}></span>
                                            </div>
                        }
                        {control.aftertext && <span>{control.aftertext}</span>}

                        {
                            control.aftertext &&
                            <label style={{ 'whiteSpace': 'pre' }}>
                                {control.aftertext}
                            </label>
                        }
                        {control.tooltip &&
                            <ReactTooltip place={control.tooltipplacement ? control.tooltipplacement : 'top'} id={control.id} aria-haspopup='true' role='example'>
                                <span>{control.tooltip}</span>
                            </ReactTooltip>
                        }
                    </div>
                </If>
                <If show={control.viewtype == 'name'}>
                    <React.Fragment>
                        {
                            control.formattype != 'plain' ?
                                <div data-tip data-for={control.id} className={control.customClass + (control.truncate ? ' text-truncate ' : ' ')}><span dangerouslySetInnerHTML={this.gethtml(control, control.Text)}></span></div>
                                :
                                <div data-tip data-for={control.id} className={control.customClass + (control.truncate ? ' text-truncate ' : ' ')}><span dangerouslySetInnerHTML={{ __html: control.Text ? control.Text : '' }}></span></div>
                        }
                        {control.tooltip &&
                            <ReactTooltip place={control.tooltipplacement ? control.tooltipplacement : 'top'} id={control.id} aria-haspopup='true' role='example'>
                                <span>{control.tooltip}</span>
                            </ReactTooltip>
                        }

                    </React.Fragment >
                </If>
                <If show={control.viewtype == 'value'}>
                    <React.Fragment>
                        {control.outputtype == 'time' && data[control.valueField] ?
                            <div data-tip data-for={control.id}
                                className={'d-flex pb-2 ' + control.customClass + control.horizontalalignment + ' ' + control.verticalalignment + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                {control.WebIcon &&
                                    <i className={(control.WebIcon) + ' mr-2'}></i>
                                }
                                <span>
                                    {this.getDistanceInWord(data[control.valueField])}
                                    {control.aftertext && <span>{control.aftertext}</span>}
                                </span>
                            </div>
                            : control.outputtype == 'datetime' && data[control.valueField] ?
                                <div data-tip data-for={control.id} className={'pb-2 ' + control.customClass + control.horizontalalignment + ' ' + control.verticalalignment + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                    {control.WebIcon &&
                                        <i className={(control.WebIcon) + ' mr-2'}></i>
                                    }
                                    {data[control.valueField] && ControlService().utcToZonedTime(data[control.valueField], control.dateformat, token)}
                                    {control.aftertext && <span>{control.aftertext}</span>}
                                </div>
                                : control.outputtype == 'email' && data[control.valueField] ?
                                    <a data-tip data-for={control.id} href={'mailto:' + data[control.valueField]}
                                        className={'pb-2 d-block ' + control.customClass + control.horizontalalignment + ' ' + control.verticalalignment + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                        {control.WebIcon &&
                                            <i className={(control.WebIcon) + ' mr-2'}></i>
                                        }
                                        {data[control.valueField]}
                                        {control.aftertext && <span>{control.aftertext}</span>}
                                    </a>
                                    : control.outputtype == 'phone' && data[control.valueField] ?
                                        <a data-tip data-for={control.id} href={'tel:' + data[control.valueField]}
                                            className={'pb-2 d-block ' + control.customClass + control.horizontalalignment + ' ' + control.verticalalignment + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                            {control.WebIcon &&
                                                <i className={(control.WebIcon) + ' mr-2'}></i>
                                            }
                                            {data[control.valueField]}
                                            {control.aftertext && <span>{control.aftertext}</span>}
                                        </a>
                                        : control.outputtype == 'website' && data[control.valueField] ?
                                            <a data-tip data-for={control.id} target="_blank" href={data[control.valueField]}
                                                className={'pb-2 d-block ' + control.customClass + control.horizontalalignment + ' ' + control.verticalalignment + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                                {control.WebIcon &&
                                                    <i className={(control.WebIcon) + ' mr-2'}></i>
                                                }
                                                {data[control.valueField]}
                                                {control.aftertext && <span>{control.aftertext}</span>}
                                            </a>
                                            : control.outputtype == 'commaSeparatedObject' && data[control.valueField] ?
                                            <div data-tip data-for={control.id}
                                                className={'d-flex pb-2 ' + control.customClass + control.horizontalalignment + ' ' + control.verticalalignment + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                                {control.WebIcon &&
                                                    <i className={(control.WebIcon) + ' mr-2'}></i>
                                                }
                                                <span>
                                                    {this.commaSeparatedMath(data[control.valueField],control.separateValueField)}
                                                    {control.aftertext && <span>{control.aftertext}</span>}
                                                </span>
                                            </div>
                                            : control.outputtype == 'commaSeparatedArray' && data[control.valueField] ?
                                            <div data-tip data-for={control.id}
                                                className={'d-flex pb-2 ' + control.customClass + control.horizontalalignment + ' ' + control.verticalalignment + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                                {control.WebIcon &&
                                                    <i className={(control.WebIcon) + ' mr-2'}></i>
                                                }
                                                <span>
                                                    {this.commaSeparatedMath(data[control.valueField])}                                                    
                                                    {control.aftertext && <span>{control.aftertext}</span>}
                                                </span>
                                            </div>
                                            : (data[control.valueField] || data[control.valueField] == 0)   &&
                                            <div data-tip data-for={control.id} className={'pb-2 ' + control.customClass + control.horizontalalignment + ' ' + control.verticalalignment + (control.maxlength ? ' text-truncate ' : ' ') + (control.truncate ? ' text-truncate ' : ' ')}>
                                                {control.WebIcon &&
                                                    <i className={(control.WebIcon) + ' mr-2'}></i>
                                                }
                                                <span title={control.maxlength > 0 ? data[control.valueField] : null} line='178'>
                                                    <span dangerouslySetInnerHTML={this.getValue(control, data)}></span>
                                                    {control.aftertext && <span>{control.aftertext}</span>}
                                                </span>
                                            </div>
                        }
                        {control.tooltip &&
                            <ReactTooltip place={control.tooltipplacement ? control.tooltipplacement : 'top'} id={control.id} aria-haspopup='true' role='example'>
                                <span>{control.tooltip}</span>
                            </ReactTooltip>
                        }
                    </React.Fragment>
                </If>
            </React.Fragment>
        );
    }
}
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading
});
export default connect(mapStateToProps, bindAction)(LabelUi);